export const GET_TRANSACTION = 'CDL_CORPORATION/get_transaction';
export const APPROVE_TRANSACTION = 'CDL_CORPORATION/approve_transaction';
export const UPDATE_TRANSACTION = 'CDL_CORPORATION/update_transaction';
export const SHOW_TRANSACTION = 'CDL_CORPORATION/show_transaction';
export const START_ASSESSMENT = 'CDL_CORPORATION/start_assessment';
export const GET_SETTINGS = 'CDL_CORPORATION/get_settings';
export const UPDATE_TEST_STATUS = 'CDL_CORPORATION/update_health_status';
export const CEDULA_URI =
  '/api/v1/administrators/transaction_histories/cedula/{id}/generate';
export const TAG_AS_PRINTED_TRANSACTION = 'CDL_CORPORATION/tag_as_printed';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const OR_CHECK = 'CDL_CORPORATION/or_check';
export const UPDATE_CDL = 'CDL_CORPORATION/update_cdl';
export const REGENERATE_CEDULA_URI =
  '/api/v1/administrators/transaction_histories/cedula/{id}/regenerate';
export const MANUAL_PAYMENT_APPROVE = 'CDL_CORPORATION/manual_payment_approve';
export const MANUAL_PAYMENT_REJECT = 'CDL_CORPORATION/manual_payment_reject';
export const APPROVE = 'CDL_CORPORATION/approve';
export const REJECT = 'CDL_CORPORATION/reject';
export const ROLLBACK = 'CDL_CORPORATION/rollback';
export const GET_LOGS = 'CDL_CORPORATION/get_logs';
export const CANCEL_APPLICATION = 'CDL_CORPORATION/cancel_application';
export const CANCEL_ASSESSMENT = 'CDL_CORPORATION/cancel_assessment';

export const GET_REGION = 'CDL_CORPORATION/get_regions';
export const GET_PROVINCE = 'CDL_CORPORATION/get_provinces';
export const GET_MUNICIPALITIES = 'CDL_CORPORATION/get_municipalities';
export const GET_BARANGAYS = 'CDL_CORPORATION/get_barangays';

export const GET_BUSINESS_LINES = 'GET_BUSINESS_LINES';
export const GET_BUSINESS_NATURE = 'GET_BUSINESS_NATURE';

export const GET_BUSINESS_NATURES_LIST =
  'CDL_CORPORATION/get_business_natures_list';
export const GET_BUSINESS_LINES_LIST =
  'CDL_CORPORATION/get_business_lines_list';

export const GENERATE_OR_URI =
  '/api/v1/administrators/transaction_histories/cedula/{id}/view_eor';

export const APPLY_DISCOUNT = 'CDL_CORPORATION/apply_discount';
export const REVOKE_CEDULA = 'CDL_CORPORATION/revoke_cedula';
export const GET_REPORT_ACCESS = 'CDL_CORPORATION/get_report_access';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const CIVIL_STATUS = [
  {
    label: 'ANNULLED',
    value: 'ANNULLED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'SEPARATED',
    value: 'SEPARATED',
  },
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'SINGLE PARENT',
    value: 'SINGLE PARENT',
  },
  {
    label: 'WIDOW',
    value: 'WIDOW',
  },
  {
    label: 'WIDOWER',
    value: 'WIDOWER',
  },
];

export const VALID_IDS = [
  {
    label: 'Authorization Letter',
    value: 'Authorization Letter',
  },
  {
    label: 'BARANGAY ID',
    value: 'BARANGAY ID',
  },
  {
    label: "DRIVER's LICENSE",
    value: "DRIVER's LICENSE",
  },
  {
    label: 'PASSPORT',
    value: 'PASSPORT',
  },
  {
    label: 'PHILHEALTH',
    value: 'PHILHEALTH',
  },
  {
    label: 'PHILSYS NATIONAL ID',
    value: 'PHILSYS NATIONAL ID',
  },
  {
    label: 'POSTAL ID',
    value: 'POSTAL ID',
  },
  {
    label: 'SSS',
    value: 'SSS',
  },
  {
    label: "SENIOR CITIZEN's ID",
    value: "SENIOR CITIZEN's ID",
  },
  {
    label: 'UMID',
    value: 'UMID',
  },
  {
    label: "VOTER's ID",
    value: "VOTER's ID",
  },
];

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};

export const CEDULA_EDIT_FORM = {
  barangay_code: '',
  president_authorized_representative: '',
  name_of_corporation_partnership: '',
  street: '',
  line_of_business_code: '',
  nature_of_business_code: '',
  date_of_registration: 'PHL',
  place_of_registration: '',
  tin: '',
  total_assessed_value_of_real_property: '',
  total_earnings_from_business: '',
  valid_id_to_present: 0,
  application_status_id: 0,
  authorized_representative_last_name: '',
  authorized_representative_middle_name: '',
  authorized_representative_first_name: '',
  authorized_representative_extension_name: '',
  nature_of_business_id: '',
  business_line_id: '',
  place_of_registration_province_code: '',
  place_of_registration_municipality_code: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR', value: 'JR' },
  { label: 'SR', value: 'SR' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
  { label: 'XI', value: 'XI' },
  { label: 'XII', value: 'XII' },
  { label: 'XIII', value: 'XIII' },
  { label: 'XIV', value: 'XIV' },
  { label: 'XV', value: 'XV' },
  { label: 'XVI', value: 'XVI' },
  { label: 'XVII', value: 'XVII' },
  { label: 'XVIII', value: 'XVIII' },
  { label: 'XIX', value: 'XIX' },
  { label: 'XX', value: 'XX' },
];
